module.exports = __webpack_public_path__ + "r-v3/img/ml_22_00.8248a893.jpg";